// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VendorSignUpHeader_wrapper__1m4J0","text":"VendorSignUpHeader_text__3D2hN"};